<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="list" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$warehouse",
					"field": "warehouseid",
					"title": "仓库",
					"props": {
						"readonly":true,
					},
					"formatter":'warehouse'
				},
				{
					"type": "$input",
					"field": "goodscode",
					"title": "商品编码",
					"props": {
						"readonly":true,
					}
				},
				{
					"type": "$input",
					"field": "goodsname",
					"title": "商品名称",
					"props": {
						"readonly":true,
					}
				},
				{
					"type": "$input",
					"field": "goodsmodel",
					"title": "规格型号",
					"props": {
						"readonly":true,
					}
				},
				{
					"type": "$input",
					"field": "weight",
					"title": "商品重量(kg)",
					"props": {
						"readonly":true,
					}
				},
				{
					"type": "$inputNumber",
					"field": "purchasenum",
					"title": "本次采购数量",
					"props": {
						"readonly":false,
						"precision":0
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				}
				
			],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [modalMixins,listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			supplieroptions: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '编辑',
				modal_width:1000,
				modal_height:600,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 350
				gridOptions.radioConfig = {
					trigger:'row'
				}
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [],
					// buttons: [{
					// 	name: '新增',
					// 	status: 'primary',
					// 	code: 'add'
					// }],
					customConfig: {
						storage: true
					},
					custom: false,
					refresh: false,
					zoom: false,
					tools: []
				}
				gridOptions.columns = [{
						type: 'radio',
						title: '#',
						width: 50,
					}, {
						field: 'supplierid',
						title: '供应商ID',
						visible:false
			
					}, {
						field: 'supplierwlnid',
						title: '供应商WLNID',
						visible:false
			
					}, {
						field: 'suppliername',
						title: '供应商名称',
			
					}, {
						field: 'suppliernameprovince',
						title: '省份',
						width: 100,
						editRender: {
							name: '$emun',
							props: {
								name:"city",
								readonly:true
							},
							events: {
								
							}
						},
					}, {
						field: 'buynum',
						title: '近一年购买次数',
						width: 100,
			
					}, {
						field: 'customizedday',
						title: '定做天数',
						width: 100,
			
					}, {
						field: 'getday',
						title: '最快到货天数',
						width: 100,
			
					}, {
						field: 'taxprice',
						title: '采购单价',
						width: 100,
					}, {
						field: 'taxamount',
						title: '采购金额',
						width: 100,			
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				this.supplieroptions.forEach((item)=>{
					item.taxamount = (item.taxprice * this.data.purchasenum).toFixed(2)
				})
				return new Promise((resolve) => {
					resolve({
						list: JSON.parse(JSON.stringify(this.supplieroptions))
					})
				})
			},
			modal_init(){
				let formData = JSON.parse(JSON.stringify(formjson))
				this.sourceData = this.data
				let rule = formData.rule.rule
				rule.forEach((item)=>{
					if(item.field == 'supplierid'){
						item.options = this.supplieroptions.map((_item)=>{
							return {..._item,...{label:_item.suppliername,value:_item.supplierid}}
						})
					}
				})
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
				let data = this.getgrid().getTableData().fullData
				data.forEach((item)=>{
					if(item.supplierid == this.data.supplierid){
						this.getgrid().setRadioRow(item)
					}
				})
				
				
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.list
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			purchasenumChange(){
				this.computeTaxamount()
			},
			computeTaxamount(){
				let purchasenum = this.fApi.getValue('purchasenum')
				let data = this.getgrid().getTableData().fullData
				data.forEach((item)=>{
					item.taxamount = (item.taxprice * parseInt(purchasenum)).toFixed(2)
				})
				
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					let form = submitData
					let data = this.getgrid().getRadioRecord()
					data.purchasenum = form.purchasenum
					data.purchaseweight = (form.weight * form.purchasenum).toFixed(4)
					this.$emit('submit',data)
					console.log(data)
					this.modal_cancel()
					// console.log(form,supplier)
				})
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>